<template>
    <div id="landing-banner">
        <v-breadcrumbs
            :items="[
                { text: 'Dashboard', to: { path: '/' } },
                {
                    text: 'OSS Configs',
                    exact: true,
                    to: { path: '/landing-banners' },
                },
                {
                    text: 'Banner Landing Page',
                },
            ]"
            divider="|"
        ></v-breadcrumbs>

        <h3 class="header-text font-weight-bold">Banner Landing Page</h3>

        <v-card>
            <v-card-title> Daftar Banner </v-card-title>
            <v-divider />
            <app-datatable
                :items="Banners"
                :headers="headers"
                :hasDetail="true"
                :custom-pagination-total-items="Banners.length"
                :custom-pagination-per-page="10"
                :custom-pagination-current-page="1"
                v-on:selected="selectedRow = $event"
                v-on:dblClicked="editliveClass()"
                v-on:changePage="
                    pagination = { ...pagination, currentPage: $event }
                "
                v-on:changeSortMode="
                    pagination = { ...pagination, sortMode: $event }
                "
                v-on:doSearch="
                    search = { query: $event.value, by: headersKey[$event.key] }
                "
            ></app-datatable>
        </v-card>

        <app-spinner v-if="isLoading"></app-spinner>
    </div>
</template>

<script>
import AppSpinner from "@/modules/global/components/plugins/Spinner";
import DataTable from "@/modules/global/components/plugins/DataTable-c";

export default {
    name: "LandingPackageList",

    components: {
        "app-datatable": DataTable,
        "app-spinner": AppSpinner,
    },

    data: function () {
        return {
            Banners: [],
            datas: null,
            selectedRow: null,
            isLoading: false,
            search: null,
            pagination: {
                perPage: 10,
                currentPage: 1,
                totalPages: 0,
                sortMode: "desc",
            },
            headers: [
                { text: "ID", value: "id", width: 70 },
                { text: "Image", value: "image" },
                { text: "URL", value: "url" },
                { text: "Type", value: "type", width: 100 },
                { text: "Status", value: "is_restricted", width: 100 },
                { text: "Aksi", value: "actions", width: 100 },
            ],
            headersKey: [
                "id",
                "image",
                "url",
                "type",
                "isActive",
                "is_home",
                "is_live_class",
            ], // camel case for matching search with API
        };
    },

    mounted: function () {
        this.fetchDatas();
    },

    methods: {
        async fetchDatas() {
            var context = this;
            this.isLoading = true;
            try {
                const resp = await this.$alioss.get(
                    `/config/landing_page.json`,
                );
                this.datas = JSON.parse(resp.res.data).hero.banners;
                this.$store.commit("landing_banners_init", this.datas);
                this.$store.commit(
                    "landing_banners_init_raw",
                    JSON.parse(resp.res.data),
                );

                this.datas.forEach(function (group, index) {
                    var row = {
                        no: index,
                        id: Number(group.id),
                        image: group.image,
                        url: group.url,
                        type: group.type,
                        is_restricted: !group.isActive,
                        datas: group,
                    };

                    context.Banners.push(row);

                    context.isLoading = false;
                });
                context.isLoading = false;
            } catch (error) {
                // isLoading hanya direset di jalur sukses, jadi tanpa baris ini
                // spinner berputar selamanya saat OSS gagal.
                context.isLoading = false;
                alert(error);
            }
        },

        editliveClass() {
            var context = this;
            this.$store.commit(
                "landing_banners_onedit",
                this.selectedRow.datas,
            );
            context.$router.push("/landing-banners/form");
        },
    },
};
</script>



// WEBPACK FOOTER //
// ListBanner.vue?23426f60